
import React from 'react';
import './App.css';

import { Link, Redirect } from 'react-router-dom';

class Reports extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            reDirect: '',
        }
    }
    componentDidMount() {

    }
    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {

                    }
                }} />
        }
        return (
            <div className="container pl-0  pr-0 ">
                <h4>
                    Case Report
                </h4>
                <hr></hr>
                <div >
                    {/* <iframe  width="1110" height="600" src="https://10.2.2.138:8443/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FTQ&reportUnit=%2Freports%2FTQ%2FClient_Report_Tracket&standAlone=true&decorate=no">Reports</iframe> */}

                </div>
                <hr></hr>
                <main>
                    <div className="row mb-2" >
                        <div>
                            <Link to="/caseSummary"><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</span></Link>

                        </div>
                    </div>


                </main>


            </div>


        )
    }
}

//         return (
//             <div>
//                               

//             </div>
//         );
//     }
// }

export default Reports;